import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

function Loader() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FCFAF6]">
      <div className="h-9 w-9 rounded-full border-2 border-[#C89B55] border-t-transparent animate-spin" />
    </div>
  );
}

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user === undefined) return <Loader />;
  if (user === null) return <Navigate to="/login" replace />;

  if (!user.onboarding_completed && location.pathname !== "/onboarding") {
    return <Navigate to="/onboarding" replace />;
  }

  // Paywall gate: once onboarding is done, members must have an active membership,
  // free trial, or comp before entering the app. Owners bypass for admin access.
  const entitled = user.entitled ?? (user.is_premium || user.role === "owner");
  if (user.onboarding_completed && !entitled && location.pathname !== "/paywall") {
    return <Navigate to="/paywall" replace />;
  }
  return children;
}
